<template>
  <div class="w-100">
    <label for="report-file-types" class="f6 b db mb2">Формат файла</label>
    <search-select
      id="report-file-types"
      class="pl2 pr1"
      :options="fileTypes"
      v-model="selectedType"
      :search-enabled="false"
      :reset-enabled="false"
      :upper-case="false"
      :show-border="false"
      style="background-color: #F0F4F8;"
    ></search-select>
  </div>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'

export default {
  props: ['value', 'types'],
  components: {
    SearchSelect
  },
  computed: {
    fileTypes () {
      return this.types.map(t => { return { name: t } })
    },
    selectedType: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
